import React, { useId } from 'react';
import {
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import BasicButton from '../../../components/button/BasicButton';

export default function AdminBulkDialog({
  action,
  title,
  children,
  onConfirm,
  disabled = false,
  confirmText = '확인',
}) {
  const titleId = useId();
  return (
    <Dialog
      open={Boolean(action.confirmation)}
      onClose={action.close}
      aria-labelledby={titleId}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { mx: 2, width: 'calc(100% - 32px)', minWidth: 0, containerType: 'inline-size' },
      }}
    >
      <DialogTitle id={titleId} sx={{ px: { xs: 1.5, sm: 3 } }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ overflowWrap: 'anywhere', px: { xs: 1.5, sm: 3 } }}>
        <Typography sx={{ mb: 2 }}>선택한 대상 {action.confirmation?.ids.length || 0}개</Typography>
        <Box
          component="fieldset"
          disabled={action.busy}
          sx={{ border: 0, p: 0, m: 0, minWidth: 0 }}
        >
          {children}
        </Box>
        {action.error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {action.error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap', gap: 1, p: 2 }}>
        <BasicButton disabled={action.busy} variant="outlined" onClick={action.close}>
          취소
        </BasicButton>
        <BasicButton disabled={action.busy || disabled} onClick={onConfirm}>
          {action.busy ? '처리 중…' : confirmText}
        </BasicButton>
      </DialogActions>
    </Dialog>
  );
}
